import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";

import useGridSize from "../../hooks/useGridSize";

import styles from './ProjectPage.module.scss';


const ProjectPage = () => {
  const params = useParams();
  const [projectData, setProjectData] = useState(null);
  const slug = params.projectSlug;
  
  const initialGridSize = window.innerWidth / 8.5;
  const gridSize = useGridSize(initialGridSize);

  const PROJECT_ID = "spalbdrt";
  const DATASET = "production";
  const GROQ_QUERY = `*[_type == 'icon' && slug == '${slug}']{
    _id,
    slug,
    project->{
    title,
    'images': images[]{
      'url': asset->url,
      text,
    },
    description,
  }
}`;
  const URL = `https://${PROJECT_ID}.api.sanity.io/v2024-04-09/data/query/${DATASET}?query=${encodeURIComponent(
    GROQ_QUERY
  )}`;

  const [activeImage, setActiveImage] = useState(null);

   useEffect(() => {
     fetch(URL)
       .then((res) => res.json())
       .then(({ result }) => {
         console.log(result[0]);
         setProjectData(result[0]);
       })
       .catch((err) => console.error(err));
   }, [URL]);

   const hanleActiveImage = (e) => {
    if (e.target.id !== 'activeImage') {
      setActiveImage(null);
    };
   }
  
   const setNextActiveImage = () => {
    const imageUrlArray = projectData.project.images.filter(obj => obj.url !== null).map(imageObj => imageObj.url);
    setActiveImage(imageUrlArray[(imageUrlArray.indexOf(activeImage) + 1) % imageUrlArray.length]);
   }

  return (
    <main>
      {projectData && (
        <>
          { activeImage && 
            (<div className={styles.activeImageContainer} onClick={(e) => { hanleActiveImage(e)}}>
              <img id="activeImage" src={activeImage} alt="active project ph" onClick={() => {setNextActiveImage()}}></img>
            </div>)}
            <div
              className={`${styles.note} ${styles.headerLink}`}
              style={{
                // top: 0 * gridSize + 0.06 * gridSize + 20,
                top: 0,
                left: 1 * gridSize + 0.06 * gridSize + 20,
                width: gridSize * 0.76,
                // height: gridSize * 0.88,
                paddingLeft: 0.06 * gridSize,
                paddingRight: 0.06 * gridSize,
                fontSize: (gridSize * 6 + 0.24 * gridSize + gridSize) / 16 + "%",
              }}
            >
              <Link to="/">Daniel Dmyszewicz</Link>
            </div>
            <main className={styles.main}>
              <div className={styles.imagesContainer}>
                {projectData.project.images.map((imageFile, i) => {
                  return (
                    (imageFile.url !== null) 
                      ? (<img src={imageFile.url} key={i} alt={i} onClick={() => setActiveImage(imageFile.url)}></img>) 
                      : (<p className={styles.projectText}>{imageFile.text}</p>)
                )})}
              </div>
            </main>
          
        </>
      )}
    </main>
  );
};

export default ProjectPage;
